import React, { useEffect, useState } from "react";
import { SourceDto } from "../../../Types/ApiTypes";
import { getAllSources } from "../../../Utils/LocalApi";
import { useTranslation } from "react-i18next";
import SourceRowItemComponent from "./SourceRowItemComponent";
import SourceModal from "./SourceModal";

const SourceListComponent = ()=>{
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation();
    const emptySource = {code: "", year: 0, name: {en: "", it: ""}}
    const [allSources, setAllSources] = React.useState<SourceDto[]>([]);
    useEffect(() => {
        getAllSources().then((value) => {
            let newSources = [] as SourceDto[];
            value.forEach((element: SourceDto) => {
                newSources.push(element);
                setAllSources([...newSources]);
            });
        });
    },[]);

    function deleteSource(id?: number){
        setAllSources(allSources.filter((source: SourceDto) => source.id !== id))
    }
    
    return (
        <div className="">
            <div className="d-flex black justify-content-between px-4 py-2 header navbar text-white bg-dark">
            </div>
            <table className='table table-responsive'>
                <thead>
                    <tr>
                        <th scope="col" className="">{t("sourcelist-id")}</th>
                        <th scope="col" className="text-start">{t("sourcelist-name")}</th>
                        <th scope="col" className="">{t("sourcelist-year")}</th>
                        <th scope="col" className="">{t("sourcelist-code")}</th>
                        <th><button className="btn btn-primary"
                                onClick={() => setIsModalOpen(true)}
                            >{t("table-add")}</button>
                            {isModalOpen && 
                            <SourceModal
                                source={emptySource}
                                updateSource={(source) => allSources.push(source)}
                                deleteSource={deleteSource}
                                closeModal={()=>{setIsModalOpen(false)}}
                            />}
                        </th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {allSources.map((source: SourceDto, index: number) =>(
                        <SourceRowItemComponent
                            source={source}
                            key={source.id}
                            deleteSource={deleteSource}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    )
}
export default SourceListComponent;
